<template>
    <div v-show="isVisible">
        <div
            class="card pointer card-select-item d-flex flex-column"
            :style="minWidth ? `min-width: ${minWidth};` : ''"
            :class="[{'selected': isSelected}, {'disabled': disabled}]"
            @click="handleClick">
            <div class="d-flex justify-content-between ml-2 align-items-center">
                <div>
                    <slot name="icon">
                        <font-awesome-icon
                            v-if="icon"
                            :icon="icon" />
                    </slot>
                </div>
                <div
                    class="custom-control"
                    :class="[{disabled: disabled}, {'custom-radio': type === 'radio'}, {'custom-checkbox': type === 'checkbox'}]">
                    <input
                        :id="elId"
                        class="custom-control-input"
                        :type="type"
                        :disabled="disabled"
                        :checked="isSelected">
                    <label
                        :for="elId"
                        class="custom-control-label"
                        @click.prevent="" />
                </div>
            </div>
            <div
                class="card-select-item-label"
                :class="{'mt-0': !icon}">
                <slot>{{ value }}</slot>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "CardSelectItem",
    inject: ['selection', 'type', 'setOption', 'registerOptionValue'],
    props: {
        value: {
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        icon: {},
        doNotRegisterOptions: {
            type: Boolean,
            default: false
        },
        isVisible: {
            type: Boolean,
            default: true
        },
        minWidth: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            elId: ""
        }
    },
    computed: {
        isSelected() {
            return this.selection().selected &&
                (this.selection().selected === this.value ||
                    (
                        Array.isArray(this.selection().selected) && this.selection().selected.find((selectedValue) => selectedValue === this.value) !== undefined
                    )
                )
        }
    },
    methods: {
        handleClick() {
            if (!this.disabled)
                this.setOption(this.value)
        }
    },
    mounted() {
        if (!this.doNotRegisterOptions)
            this.registerOptionValue(this.value)

        this.elId = Math.random()
            .toString(16)
            .slice(2);
    },
    watch: {
        //Remove Selection if Item is not Visible but was selected
        isVisible:{
            handler(isVisible) {
                if (!isVisible && this.isSelected) {
                    this.setOption(this.value)
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .card-select-item {
        user-select: none;

        &.selected {
            background-color: lighten($default, 63%);
        }

        &.disabled {
            color: $gray-500;
            cursor: not-allowed;

            :deep(.custom-control-label) {
                cursor: not-allowed;
            }
        }
    }


    .form-group.is-invalid .card-select-item {
        background-color: lighten($danger, 38%);
    }
</style>
